<template>
    <!-- HEADER -->
    <div class="header">
      <div class="container-fluid">
        <div class="card mt-5">
          <div class="card-header">
            <!-- Title -->
            <h4 class="card-header-title">Role Menu Management</h4>
          </div>
          <vue-good-table
            :line-numbers="true"
            :columns="columns"
            :rows="list"
            :sort-options="{
              enabled: false
            }"
            :total-rows="10"
            :pagination-options="{
              enabled: true,
              mode: 'pages',
              position: 'bottom',
              perPage: 10,
              perPageDropdown: [10, 50, 100],
              dropdownAllowAll: false,
              setCurrentPage: 1,
              nextLabel: 'next',
              prevLabel: 'prev',
              rowsPerPageLabel: 'Rows per page',
              ofLabel: 'of',
              pageLabel: 'page',
              allLabel: 'All'
            }"
            style-class="vgt-table border-0 table"
            @on-page-change="onPageChange"
            @on-per-page-change="onPageChange">
            <!-- Loading -->
            <div slot="emptystate" class="text-center font-size-14">
              No data available
            </div>

            <!-- Custom Rows -->
          <template slot="table-row" slot-scope="props">
            <!-- Table Action -->
            <span v-if="props.column.field == 'action'">
              <b-button
                v-if="listTabMenu?.privilages?.update"
                class="no-wrap btn-pill"
                variant="warning"
                size="sm"
                @click="updateData(props.row)">
                <span class="fe fe-edit"></span>
              </b-button>
            </span>
          </template>
          </vue-good-table>
        </div>
  
        <!-- Modal -->
        <b-modal
          id="modal-1"
          centered
          hide-footer
          title="Edit Menu"
          size="lg">
          <form @submit.prevent="saveUpdate()">
            <div class="form-group">
              <label>Title</label>
              <input
                v-validate="'required'"
                name="Title"
                type="text"
                v-model="bodyUpdate.title"
                class="form-control"
                placeholder="Title" />
              <span class="text-sm text-danger" v-show="errors.has('Title')" >{{ errors.first("Title") }}</span>
            </div>
            <div class="form-group">
              <label>To</label>
              <input
                v-validate="'required'"
                name="To"
                type="text"
                v-model="bodyUpdate.to"
                class="form-control"
                placeholder="To" />
              <span class="text-sm text-danger" v-show="errors.has('To')" >{{ errors.first("To") }}</span>
            </div>
            <div class="form-group">
              <label>Icon</label>
              <input
                type="text"
                v-model="bodyUpdate.icon"
                class="form-control"
                placeholder="Icon" 
              />
            </div>
            <div class="form-group">
              <label>Parent ID</label>
              <input
                v-validate="'required'"
                name="Parent ID"
                type="text"
                v-model="bodyUpdate.parent_id"
                class="form-control"
                placeholder="Parent ID" />
              <span class="text-sm text-danger" v-show="errors.has('Parent ID')" >{{ errors.first("Parent ID") }}</span>
            </div>
            <div class="form-group">
              <label>Order ID</label>
              <input
                v-validate="'required'"
                name="Order"
                type="text"
                v-model="bodyUpdate.order"
                class="form-control"
                placeholder="Order" />
              <span class="text-sm text-danger" v-show="errors.has('Order')" >{{ errors.first("Order") }}</span>
            </div>
            <div class="form-group">
              <div class="row">
                <div class="col-lg-3 col-12">
                  <div class="form-check">
                    <input 
                      type="checkbox" 
                      class="form-check-input" 
                      id="is_active" 
                      v-model="bodyUpdate.is_active"
                    >
                    <label class="form-check-label" for="is_active">Is Active</label>
                  </div>
                </div>
                <div class="col-lg-3 col-12">
                  <input 
                    type="checkbox" 
                    class="form-check-input" 
                    id="is_menu" 
                    v-model="bodyUpdate.is_menu"
                  >
                  <label class="form-check-label" for="is_menu">Is Menu</label>
                </div>
              </div>
            </div>
  
            <div class="form-group">
              <button
                style="margin-left: auto; float: right"
                class="mt-4 btn btn-primary"
                type="submit"
                v-if="isLoading == false">
                Save
              </button>
              <button
                style="margin-left: auto; float: right"
                class="mt-4 btn btn-primary"
                type="button"
                disabled
                v-else>
                <span
                  class="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"></span>
                Loading...
              </button>
            </div>
          </form>
        </b-modal>
      </div>
    </div>
  </template>
  <script>
  export default {
    name: "trainingType",
    computed: {
      list() {
        return this.$store.getters["menu/menu"];
      },
    },
    data() {
      return {
        body: {
          page: 1,
          limit: 10
          // order: "",
          // search: "",
        },
        listTabMenu: {},
        bodyUpdate: {
          id: "",
          title: "",
          icon: "",
          to: "",
          parent_id: "",
          order: "",
          is_active: false,
          is_menu: false,
        },
        isAdd: true,
        isLoading: false,
        openItems: {},
        columns: [
          {
            label: "id",
            field: "id",
            thClass: "table-header text-muted w-25 font-weight-bold",
            tdClass: "color-secondary align-middle"
          },
          {
            label: "Name",
            field: "title",
            thClass: "table-header text-muted w-25 font-weight-bold",
            tdClass: "color-secondary align-middle"
          },
          {
            label: "Link",
            field: "to",
            thClass: "table-header text-muted w-25 font-weight-bold",
            tdClass: "color-secondary align-middle"
          },
          {
            label: "Icon",
            field: "icon",
            thClass: "table-header text-muted w-25 font-weight-bold",
            tdClass: "color-secondary align-middle"
          },
          {
            label: "ACTION",
            field: "action",
            thClass: "table-header no-wrap text-muted font-weight-bold",
            tdClass: "no-wrap color-secondary align-middle",
            sortable: false
          }
        ]
      };
    },
    mounted() {
      this.getList();
      const listMenu = JSON.parse(localStorage.getItem('listMenu') || [])
      const currentPath = window.location.pathname; // Path dari URL saat ini
      const menu = listMenu.find((menu) =>
        menu.link === currentPath || menu.children.find((child) => child.link === currentPath)
      );
      this.listTabMenu = menu.children.find((item) => item.link === currentPath);
    },
    methods: {
      toggleItem(menuId) {
        this.$set(this.openItems, menuId, !this.openItems[menuId]);
      },
      isOpen(menuId) {
        return !!this.openItems[menuId];
      },
      updateMenuSelection(item) {
        if (item.check) {
          if (!this.bodyUpdate.menu.includes(item.menuId)) {
            this.bodyUpdate.menu.push(item.menuId);
          }
        } else {
          this.bodyUpdate.menu = this.bodyUpdate.menu.filter(
            (id) => id !== item.menuId
          );
        }
  
        if (item.children) {
          item.children.forEach((child) => {
            child.check = item.check;
            if (item.check) {
              if (!this.bodyUpdate.menu.includes(child.menuId)) {
                this.bodyUpdate.menu.push(child.menuId);
              }
            } else {
              this.bodyUpdate.menu = this.bodyUpdate.menu.filter(
                (id) => id !== child.menuId
              );
            }
          });
        }
      },
      //action
      updateData(props) {
        this.$bvModal.show("modal-1");
        this.isAdd = false;
        this.bodyUpdate.id = props.id;
        this.bodyUpdate.title = props.title;
        this.bodyUpdate.icon = props.icon;
        this.bodyUpdate.to = props.to;
        this.bodyUpdate.parent_id = props.parent_id;
        this.bodyUpdate.order = props.order;
        this.bodyUpdate.is_active = props.is_active;
        this.bodyUpdate.is_menu = props.is_menu;
      },
  
      saveUpdate() {
        this.isLoading = true;
        this.$store.dispatch("menu/updateMenu", this.bodyUpdate)
          .then((resp) => {
            this.$swal({
              title: "Tersimpan",
              text: "Data berhasil disimpan",
              icon: "success",
              confirmButtonText: "OK"
            }).then((resp) => {
              this.isLoading = false;
              this.getList();
              this.$bvModal.hide("modal-1");
            });
          })
          .catch((resp) => {
            this.$swal("Error", resp.response.data.error, "error");
          });
      },
  
      // api hit
      getList() {
        this.$store.dispatch("menu/getMenu");
      },
      sorting() {
        this.getList();
        this.body.page = 1;
      },
  
      // Pagination
      onPageChange(payload) {
        this.body.limit = payload.currentPerPage;
        this.body.page = payload.currentPage;
        this.getList();
      }
    }
  };
  </script>
  <style>
  .list {
    list-style-type: none;
    padding: 0;
    margin: 0;
  }
  
  .list-item {
    display: flex;
    align-items: center;
    cursor: pointer;
    padding: 10px 15px;
    margin: 5px 0;
    background-color: #f9f9f9;
    border: 1px solid #ddd;
    border-radius: 5px;
    transition: background-color 0.3s, box-shadow 0.3s;
  }
  
  .list-item:hover {
    background-color: #f1f1f1;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }
  
  .list-item input[type="checkbox"] {
    margin-right: 10px;
  }
  
  .list-item span {
    /* flex-grow: 1; */
    font-family: "Arial", sans-serif;
    font-size: 16px;
    color: #333;
  }
  </style>
  